
const sizeCharts = {

  /* ================= NORMAL / MISSY ================= */
  normal: {
    inches: {
      headers: ["SIZE", "US SIZE", "BUST (in)", "WAIST (in)", "HIPS (in)"],
      rows: [
        ["XXS", "0", "31 1/2", "23 1/2", "34"],
        ["XS", "2", "33", "25", "35 1/2"],
        ["S", "4–6", "34 1/2", "26 1/2", "37"],
        ["M", "8–10", "37 1/2", "29 1/2", "40"],
        ["L", "12–14", "40 1/2", "32 1/2", "43"],
        ["XL", "16–18", "43 1/2", "35 1/2", "46"],
        ["1X", "16/18W", "44 1/2", "36 1/2", "47"],
        ["2X", "20/22W", "47 1/2", "39 1/2", "50"],
        ["3X", "24W/26W", "50 1/2", "42 1/2", "53"]
      ]
    },
    metric: {
      headers: ["SIZE", "US SIZE", "BUST (cm)", "WAIST (cm)", "HIPS (cm)"],
      rows: [
        ["XXS", "0", "80", "60", "86"],
        ["XS", "2", "84", "64", "90"],
        ["S", "4–6", "88", "67", "94"],
        ["M", "8–10", "95", "75", "102"],
        ["L", "12–14", "103", "83", "109"],
        ["XL", "16–18", "110", "90", "117"],
        ["1X", "16/18W", "113", "93", "119"],
        ["2X", "20/22W", "121", "100", "127"],
        ["3X", "24W/26W", "128", "108", "135"]
      ]
    }
  },

  /* ================= PETITE ================= */
  petite: {
    inches: {
      headers: ["SIZE", "US SIZE", "BUST (in)", "WAIST (in)", "HIPS (in)"],
      rows: [
        ["PXS", "0-2", "31 1/2", "23 1/2", "34"],
        ["PS", "4-6", "33", "25", "35 1/2"],
        ["PM", "8-10", "36", "28", "38 1/2"],
        ["PL", "12-14", "39", "31", "41 1/2"],
        ["PXL", "16-18", "42", "34", "44 1/2"],
        ["P1X", "16/18W", "43", "35", "45 1/2"],
        ["P2X", "20/22W", "46", "38", "48 1/2"],
        ["P3X", "24W/26W", "49", "41", "51 1/2"]
      ]
    },
    metric: {
      headers: ["SIZE", "US SIZE", "BUST (cm)", "WAIST (cm)", "HIPS (cm)"],
      rows: [
        ["PXS", "0-2", "80", "60", "86"],
        ["PS", "4-6", "84", "64", "90"],
        ["PM", "8-10", "91", "71", "98"],
        ["PL", "12-14", "99", "79", "105"],
        ["PXL", "16-18", "107", "86", "113"],
        ["P1X", "16/18W", "109", "89", "116"],
        ["P2X", "20/22W", "117", "97", "123"],
        ["P3X", "24W/26W", "124", "104", "131"]
      ]
    }
  },

  /* ================= TALL ================= */
  tall: {
    inches: {
      headers: ["SIZE", "US SIZE", "BUST (in)", "WAIST (in)", "HIPS (in)"],
      rows: [
        ["XST", "2-4", "34 1/2", "26 1/2", "37"],
        ["ST", "6", "36", "28", "38 1/2"],
        ["MT", "8-10", "39", "31", "41 1/2"],
        ["LT", "12-14", "42", "34", "44 1/2"],
        ["XLT", "16-18", "45", "37", "47 1/2"]
      ]
    },
    metric: {
      headers: ["SIZE", "US SIZE", "BUST (cm)", "WAIST (cm)", "HIPS (cm)"],
      rows: [
        ["XST", "2-4", "88", "67", "94"],
        ["ST", "6", "91", "71", "98"],
        ["MT", "8-10", "99", "79", "105"],
        ["LT", "12-14", "107", "86", "113"],
        ["XLT", "16-18", "114", "94", "121"]
      ]
    }
  }
};

